<template>
  <div>
    <v-list>
      <v-list-group value="Actions">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" :title="menu.MenuText"></v-list-item>
        </template>
        <template v-for="(menuItem, index) in menu.submenu">
          <mobile-menu-parent-item
            :key="index"
            v-if="!menuItem.submenu"
            :menu="menuItem"
            :menuId="index"
          />
        </template>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
import MobileMenuParentItem from "@/components/mobile_menu/MobileMenuParentItem.vue";
export default {
  components: { MobileMenuParentItem },
  props: {
    menu: {
      type: Object,
      required: true,
    },
    menuId: {
      required: true,
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
</style>